import React from 'react';
import { connect } from 'react-redux';
import { accountActions, orderActions } from '@/actions/trading';
import { stockActions } from '@/actions/trading/stock.action';
import '@/assets/styles/components/order/order-modify.scss';
import { Icons, SERVICES_RESP } from '@/configurations';
import { ORDER_MODE } from '@/constants/app';
import { dataType } from '@/constants/data-type';
import { PARAMS } from '@/constants/params';
import { formatFunctions } from '../../helpers/functions';
import PlaceOrderOption from '../Instrument/PlaceOrderOption';
import OrderConfirmStatus from '../OrderConfirm/OrderConfirmStatus';
import Tips from '../Tips/Tips';
import { tipsType } from '@/constants/tips-type';
import OrderInformation from './OrderInformation';
import classnames from 'classnames';
import OrderConfirmStatusMobile from "@/components/OrderConfirm/OrderConfirmStatus.mobile";
import { openOrderConfirm } from '@/actions/app';
class OrderModify extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowResult: false,
      orderResult: {},
      orderData: {},
      isLoading: true,
      spreadTable: [],
      lotSize: 1,
      prevPrice: 0,
      prevQty: 0,
      errorText: '',
      isLoadingConfirm: false,
      grossAmount: '-',
      tmpPriceQty: {},
      isVisible:true
    }
  }

  render() {
    const { language, isMobile } = this.props;
    const {
      isShowResult,
      orderResult,
      orderData,
      isLoading,
      lotSize,
      spreadTable,
      errorText,
      isLoadingConfirm,
      grossAmount,
      isVisible
    } = this.state;

    return (
      <React.Fragment>
        {isShowResult
          ? isMobile
            ? <OrderConfirmStatusMobile
              mode={ORDER_MODE.MODIFY}
              orderResult={orderResult}
              onTradeAgain={this.handleTradeAgain} />
            : <OrderConfirmStatus
              mode={ORDER_MODE.MODIFY}
              orderData={orderData}
              orderResult={orderResult}
              onClose={this.handleClose} />
          : !isLoading &&
          <React.Fragment>
            <div style={{ display: isVisible ? 'block' : 'none' }} className={classnames("order-modify-container", isMobile && "order-modify-container-mobile")}>
              <header>{language.order_confirm_message.format(language.order_modify_title)}</header>
              <OrderInformation order={orderData} mode={ORDER_MODE.MODIFY} />
              <div className="modify-input">
                <PlaceOrderOption
                  isModifyOrder={true}
                  innerRef={e => this.placeOrderOptionRef = e}
                  spreadTable={spreadTable}
                  lotSize={lotSize}
                  onChange={this.handleChangeOption}
                  showGrossAmount
                />
                {/* <div className="input-item">
                  <label>{language.common_gross_amount}</label>
                  <div className="gross-amount">
                    {grossAmount}
                  </div>
                </div> */}
              </div>
              {
                errorText &&
                <section>
                  <Tips isNoBgColor tipsType={tipsType.error}>
                    {errorText}
                  </Tips>
                </section>
              }
              <div className={classnames("action", isMobile && 'action-mobile')}>
                <button type="button" className='cancel' onClick={() => {
                  this.props.onClose(true)
                }}>{language.common_cancel}</button>
                <button type="button" className='confirm' onClick={this.validateOrderRequest}>
                  {isLoadingConfirm ? <Icons.Loading /> : language.common_confirm}
                </button>
              </div>
            </div>
          </React.Fragment>
        }
      </React.Fragment>
    )
  }

  handleTradeAgain = () => {
    this.setState({ isShowResult: false }, () => {
      this.placeOrderOptionRef.setPrice(this.state.tmpPriceQty.price);
      this.placeOrderOptionRef.setQuantity(this.state.tmpPriceQty.qty);
    })
  }

  handleChangeOption = (options) => {
    const grossAmount = options.price * options.quantity;
    const { orderData } = this.state;
    let grossAmountText = `${orderData.currencyID} ${formatFunctions.dataFormat(grossAmount, dataType.CURRENCY)}`
    this.setState({ grossAmount: grossAmountText })
  }

  handleClose = (isCloseDialog = true) => {
    if (isCloseDialog) {
      this.props.onClose();
    } else {
      this.setState({ isShowResult: false }, () => {
        this.placeOrderOptionRef.setQuantity(this.state.prevQty)
        this.placeOrderOptionRef.setPrice(this.state.prevPrice)
      })
    }
  }

  getAvailableQuantity = (qty) => {
    this.setState({ isLoadingConfirm: true })
    const { language, currentTradingAccount } = this.props;
    const { orderData } = this.state;

    const params = {
      [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
      [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
      [PARAMS.MARKET_ID]: orderData.marketID,
      [PARAMS.INSTRUMENT_ID]: orderData.instrumentID,
      [PARAMS.LANGUAGE]: language.lang
    }
    this.props.getAvailableQuantity(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          if (res.result.avaiableQuantity == 0) {
            this.setState({ errorText: language.error_message_available_qty_zero })
          } else if(qty > res.result.avaiableQuantity){
            this.setState({ errorText: language.error_message_more_than_available_qty })
          } else {
            this.handleConfirm();
          }
        }
      }
      this.setState({ isLoadingConfirm: false })
    })
  }

  validateOrderRequest = () => {
    const options = this.placeOrderOptionRef.getOptions();
    const { orderData } = this.state;
    this.setState({ errorText: '' })
    let qty = parseInt(options.quantity)
    if (orderData.bs === 'S' && qty > orderData.qty) {
      this.getAvailableQuantity(qty);
    } else {
      this.handleConfirm();
    }
  }

  handleConfirm = () => {
    const options = this.placeOrderOptionRef.getOptions();
    const orderData = {
      ...this.state.orderData,
      isModifyOrder: 'Y',
      newPrice: options.price,
      newQTY: options.quantity,
      isBuy:this.state.orderData.bs === 'B'
    }
    this.setState({ isVisible: false })
    openOrderConfirm(orderData, (isCloseDialog = true) => {
      if (isCloseDialog) {
        this.props.onClose()
      } else {
        this.setState({ isVisible: true });
      }
    })
  }

  handleGetSpreadTable(spreadTableCode) {
    const { language } = this.props;
    const params = {
      [PARAMS.SPREAD_TABLE_CODE]: spreadTableCode,
      [PARAMS.LANGUAGE]: language.lang
    }
    this.props.getSpreadTable(params, res => {
      if (res.status === SERVICES_RESP.STATUS_OK) {
        if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          this.setState({ spreadTable: res.result.spreadTableList }, () => {
            this.placeOrderOptionRef.setQuantity(this.state.orderData.qty)
            this.placeOrderOptionRef.setPrice(this.state.orderData.price)
            setTimeout(() => {
              this.placeOrderOptionRef.handleChangePrice(this.state.orderData.price);
            }, 0);
          })
        }
      }
    })
  }

  handleSearchInstrument = (instrumentID) => {
    const { language, currentMarket } = this.props;
    if (instrumentID) {
      const params = {
        [PARAMS.MARKET_ID]: currentMarket,
        [PARAMS.INSTRUMENT_ID]: instrumentID,
        [PARAMS.LANGUAGE]: language.lang
      }
      this.props.getInstrumentDetail(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            this.setState({ lotSize: res.result.lotsize });
            this.handleGetSpreadTable(res.result.spreadTableCode)
          }
        }
      })
    }
  }

  getData = () => {
    const { currentTradingAccount, language, order } = this.props
    if (currentTradingAccount.clientID) {
      if (order.bs) {
        this.setState({ orderData: order }, () => {
          this.handleSearchInstrument(order.instrumentID)
        });
        this.setState({ isLoading: false })
      } else {
        const params = {
          [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
          [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
          [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
          [PARAMS.ORDER_GROUP_ID]: order.orderGroupID,
          [PARAMS.LANGUAGE]: language.lang
        }
        this.props.getOrderDetail(params, res => {
          if (res.status === SERVICES_RESP.STATUS_OK) {
            if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
              const orderData = res.result.orderInfoList.length > 0 ? res.result.orderInfoList[0] : order;
              this.setState({ orderData });
              this.handleSearchInstrument(orderData.instrumentID)
            }
          }
          this.setState({ isLoading: false })
        })
      }
    }
  }

  componentDidMount() {
    this.getData();
  }
}

export default connect(
  state => ({
    language: state.app.language,
    isMobile: state.app.isMobile,
    currentTradingAccount: state.trade.currentTradingAccount,
    currentMarket: state.trade.currentMarket
  }),
  dispatch => ({
    getOrderDetail: (p, c) => dispatch(orderActions.getOrderDetailAction(p, c)),
    modifyOrder: (p, res) => dispatch(orderActions.modifyOrderAction(p, res)),
    getInstrumentDetail: (p, res) => dispatch(stockActions.getInstrumentDetailAction(p, res)),
    getSpreadTable: (p, res) => dispatch(stockActions.getSpreadTableAction(p, res)),
    getAvailableQuantity: (p, res) => dispatch(accountActions.getAvailableQuantityAction(p, res))
  })
)(OrderModify)
